/* unplugin-vue-components disabled */import { render } from "./ContactMe.vue?vue&type=template&id=71d1c45b&scoped=true"
import script from "./ContactMe.vue?vue&type=script&lang=js"
export * from "./ContactMe.vue?vue&type=script&lang=js"

import "./ContactMe.vue?vue&type=style&index=0&id=71d1c45b&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d1c45b"]])

export default __exports__